import { render, staticRenderFns } from "./PoliciesBlock.vue?vue&type=template&id=dd916de8"
import script from "./PoliciesBlock.vue?vue&type=script&lang=js"
export * from "./PoliciesBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports